import axiosInstance from "../services/axiosInstance";
import { API_ENDPOINTS } from "../services/api/apiConfig";
import type { Doctor } from "../types";
import { useQuery } from "@tanstack/react-query";

export const useDoctorData = (id?: string) => {
  const doctorId = id ? Number(id) : undefined;

  const listQuery = useQuery({
    queryKey: ['doctors', 'list'],
    queryFn: async () => {
      const response = await axiosInstance.get(API_ENDPOINTS.USERS.DOCTORS.LIST);
      return response.data as Doctor[];
    },
    enabled: !id,
  });

  const singleQuery = useQuery({
    queryKey: ['doctor', doctorId],
    queryFn: async () => {
      if (!doctorId) return null;
      const response = await axiosInstance.get(API_ENDPOINTS.USERS.DOCTORS.GET_BY_ID(doctorId));
      return response.data as Doctor;
    },
    enabled: !!id,
  });

  const loading = id ? singleQuery.isLoading : listQuery.isLoading;
  const error = id ? (singleQuery.error ? (singleQuery.error as any).message : null) : (listQuery.error ? (listQuery.error as any).message : null);

  return {
    doctors: listQuery.data || [],
    doctor: singleQuery.data || null,
    loading,
    error,
  };
};

